import zone from './zone'
import current from './current'
import sync from './sync'
import gnaviStart from './gnaviStart'
import password from './pos/password'
/**
 * 店舗
 */
export default {
  namespaced: true,
  state: {
    byId: {},
    allIds: [],
  },
  modules: {
    zone,
    current,
    sync,
    gnaviStart,
    password,
  },
  getters: {
    all: ({ byId, allIds }) => allIds.map(id => byId[id]),
  },
}
